import type { WordCollection } from "../collection.types";

export const highSunCollection: WordCollection = {
  id: "high-sun",
  title: "High Sun & Wildfire",
  icon: "white-balance-sunny",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 5, 1), // June 1st
  endDate: new Date(new Date().getFullYear(), 6, 31), // July 31st
  words: [
    "bright",
    "brilliant",
    "burn",
    "burst",
    "climb",
    "dance",
    "desert",
    "electricity",
    "energy",
    "fast",
    "fierce",
    "flame",
    "flash",
    "flow",
    "gold",
    "grow",
    "heat",
    "high",
    "hot",
    "intense",
    "lightning",
    "orange",
    "peak",
    "power",
    "quick",
    "reach",
    "red",
    "rise",
    "rush",
    "sky",
    "spread",
    "steam",
    "storm",
    "strong",
    "summer",
    "sun",
    "vapor",
    "vibrant",
    "warm",
    "wave",
    "wild",
    "wind",
    "yellow",
  ],
};
